export const GATEWAY_MAT_COOKIE_KEY = 'gateway_authorization_token';
export const GATEWAY_PAT_HEADER_KEY = 'x-private-access-token';
